const it = {
  nav: { about: "Chi siamo", services: "Servizi", logistics: "Logistica", clients: "Clienti", news: "News", contact: "Contatti", cta: "Richiedi consulenza", menu: "Menu", close: "Chiudi" },
  global: {
    eyebrow: "Il mondo in movimento",
    title: "Dalla Costiera alle _grandi capitali_.",
    intro: "Persone che fanno affari, merci che viaggiano: questo è il mondo in cui lavoriamo ogni giorno.",
    capitals: "Grandi capitali",
    deals: "Persone & affari",
    base: "La mia base: la Costiera",
    ops: "Merci in movimento",
    timezones: "Fusi orari",
    newsTicker: "News dal mondo · sempre aggiornate · leggi più giù nella sezione News & Mercati",
  },
  news: {
    eyebrow: "06 — News & Mercati",
    title: "Il mondo dei trasporti, _in tempo reale_.",
    intro: "Notizie aggiornate automaticamente dai principali portali della logistica internazionale.",
    read: "Leggi",
    updated: "Aggiornato",
  },
  hero: {
    eyebrow: "Consulenza aziendale · Import Export · Logistica",
    lines: ["Muoviamo", "le imprese", "_oltre_ confine."],
    sub: "Affianchiamo le aziende nell'import-export, nelle procedure documentali, nell'ingresso su nuovi mercati e nella logistica internazionale: dal primo contatto alla consegna.",
    cta: "Parliamo del tuo progetto",
    cta2: "Scopri i servizi",
    scroll: "Scorri",
    tags: ["Mare", "Aria", "Terra", "Corriere"],
    frame: "Rotte globali, un unico interlocutore",
  },
  marquee: ["Import · Export", "Procedure documentali", "Temperatura controllata", "Merci pericolose DGR", "Trasporto marittimo", "Air cargo", "Trasporto su strada", "Magazzinaggio & imballaggio", "Sviluppo mercati"],
  about: {
    eyebrow: "01 — Chi siamo",
    title: "Un consulente, una rete, _un metodo_ per crescere all'estero.",
    body1: "MF Logistics Consulting Group nasce per dare alle imprese un punto di riferimento unico quando decidono di vendere, comprare o produrre oltre i confini nazionali.",
    body2: "Uniamo competenze documentali, conoscenza dei mercati e operatività logistica per trasformare un'idea di espansione in un flusso concreto di merci, contratti e relazioni.",
  founderRole: "Fondatrice & CEO",
  founderLine: "Una lunga esperienza internazionale in Europa e nel mondo: accompagno le imprese oltre i confini, con cura e metodo.",
  doorCaption: "La mia porta è sempre aperta",
    pillars: [
      { t: "Visione d'insieme", d: "Strategia commerciale, documenti e trasporti letti come un unico progetto." },
      { t: "Operatività reale", d: "Seguiamo ogni spedizione e ogni pratica fino alla chiusura." },
      { t: "Rete di contatti", d: "Partner, fornitori e buyer selezionati sui mercati di destinazione." },
    ],
  },
  services: {
    eyebrow: "02 — Servizi",
    title: "Consulenza su misura, _dalla carta_ al container.",
    intro: "Ogni azienda ha esigenze diverse: costruiamo il percorso più adatto alla tua realtà.",
    items: [
      { t: "Import & Export", d: "Pianificazione dei flussi, scelta di Incoterms, fornitori e partner logistici per comprare e vendere all'estero in sicurezza." },
      { t: "Procedure documentali", d: "Pratiche doganali, certificati d'origine, documenti di trasporto e conformità normativa gestiti con precisione." },
      { t: "Introduzione prodotti sul mercato", d: "Analisi del mercato target, requisiti di ingresso e strategia di lancio per i tuoi prodotti." },
      { t: "Sviluppo aziendale sui mercati", d: "Piani di internazionalizzazione e crescita commerciale su nuovi paesi e canali." },
      { t: "Sviluppo contatti", d: "Ricerca e qualificazione di buyer, distributori e partner sul mercato di interesse." },
      { t: "Sviluppo ordini dai mercati esteri", d: "Ricerca clienti internazionali e gestione delle richieste d'ordine, dal primo contatto all'ordine confermato." },
      { t: "Consulenza aziendale", d: "Supporto su organizzazione, processi e ogni altra esigenza legata alla tua attività d'impresa." },
    ],
  },
  logistics: {
    eyebrow: "03 — Logistica",
    title: "Qualsiasi merce, _qualsiasi_ via.",
    intro: "Organizziamo spedizioni complete per ogni tipologia di merce e modalità di trasporto, con magazzinaggio e imballaggio inclusi.",
    modesTitle: "Modalità di trasporto",
    modesDesc: "Combiniamo nave, aereo, strada e corriere per trovare il giusto equilibrio tra tempi, costi e sicurezza.",
    modes: ["Nave", "Aereo", "Strada", "Corriere"],
    goodsTitle: "Tipologie di merce",
    goods: [
      { t: "Temperatura ambiente — General cargo", d: "Merce generale, collettame e carichi completi." },
      { t: "Temperatura controllata", d: "Catena del freddo e range termici dedicati." },
      { t: "Merci pericolose DGR", d: "Gestione documentale e operativa ADR / IMDG / IATA." },
    ],
    subsLabel: "Sotto-categorie di carico",
    subs: ["Food & deperibili (anche congelati)", "Farmaceutici", "Macchinari & macchine", "Beni di lusso", "Abbigliamento", "Cosmetici", "…e altro"],
    insurance: { t: "Assicurazione merce", d: "Tutela completa del tuo carico su ogni tratta." },
    docsPermits: { t: "Documenti & permessi", d: "Registrazioni, certificati sanitari, permessi di ingresso e ogni pratica." },
    palletControl: { t: "Pallettizzazione & controllo", d: "Storage, pallettizzazione e controllo merce in magazzino." },
    warehousing: { t: "Magazzinaggio", d: "Stoccaggio, gestione scorte e distribuzione." },
    packaging: { t: "Imballaggio", d: "Imballi idonei a merce, modalità e normative." },
    customs: { t: "Documenti & dogana", d: "Dalla bolla al certificato: ogni carta al suo posto." },
  },
  newsletter: {
    eyebrow: "La newsletter",
    titleAccent: "Resta aggiornato",
    title: " col mondo.",
    sub: "Ogni mese: rotte, mercati e consigli pratici per vendere e comprare oltre confine. Niente spam.",
    placeholder: "La tua email",
    cta: "Iscriviti",
    sending: "Invio…",
    ok: "Iscrizione confermata! Riceverai le nostre news.",
    already: "Sei già iscritto alla newsletter.",
    error: "Si è verificato un errore. Riprova.",
    privacy: "Iscrivendoti accetti di ricevere le nostre comunicazioni. Niente spam: ti puoi cancellare quando vuoi.",
  },
  clients: {
    eyebrow: "04 — Clienti",
    title: "Aziende che hanno scelto i _nostri servizi_.",
    intro: "Alcune delle realtà che abbiamo accompagnato sui mercati internazionali.",
    consTitle: "Con la _consulenza_.",
    impTitle: "Con l'_import-export_.",
    placeholder: "[Logo cliente]",
    visit: "Visita",
  },
  contact: {
    eyebrow: "05 — Contatti",
    title: "Raccontaci _dove_ vuoi arrivare.",
    intro: "Scrivici: ti ricontattiamo per capire insieme il percorso migliore.",
    fields: { name: "Nome e cognome", company: "Azienda", email: "Email", phone: "Telefono", service: "Di cosa hai bisogno?", message: "Messaggio" },
    servicePick: "Seleziona un servizio",
    logisticsOption: "Spedizioni e logistica",
    submit: "Invia richiesta",
    sending: "Invio in corso…",
    success: "Grazie! Abbiamo ricevuto la tua richiesta e ti ricontatteremo a breve.",
    error: "Invio non riuscito. Controlla i campi e riprova.",
    direct: "Contatto diretto",
    emailLabel: "Email",
    phoneLabel: "Telefono",
    vatLabel: "P.IVA",
    addressLabel: "Sede",
  },
  footer: { tagline: "Consulenza aziendale, import-export e logistica internazionale.", rights: "Tutti i diritti riservati.", admin: "Area riservata", top: "Torna su" },
};
export default it;
